<template>
  <div class="m-grid m-grid--hor m-grid--root m-page">


    <main-menu></main-menu>


    <event-hub></event-hub>

    <transition name="fade" mode="out-in">
      <router-view
        :message="message"
        @messageEvent="message = $event"
      ></router-view>
    </transition>

  </div>
</template>

<script>
import MainMenu from '../components/Menu'
import SmMenu from '../components/SmMenu.vue'
import LeftMenu from '../components/LeftMenu/LeftMenu.vue'

export default {
  components: {
    'main-menu': MainMenu,
    'sm-menu': SmMenu,
    'left-menu': LeftMenu,
  },
  data() {
    return {
      message: null
    }
  },
  watch: {
    message: function () {
      setTimeout(() => this.message = null, 3000)
    }
  }
}
</script>

<style lang="scss">
@import '../../node_modules/vue-awesome-notifications/dist/styles/style';

.flex {
  display: flex !important
}

.full-width {
  width: 100%;
}

.form-group {
  .form-control-feedback {
    display: none;
  }

  &.show-feedback {
    .form-control-feedback {
      display: block;
    }
  }
}

.agenda {
  &.m-content {
    padding-top: 0 !important;
  }

  &.m-content {
    padding-left: 15px !important;
  }
}

.m-header-menu {
  float: right;
}
</style>




// WEBPACK FOOTER //
// src/views/Main.vue